(function () {
  var swatchSelector = '[data-combined-product-swatch]';
  var swatchesSelector = '[data-combined-product-swatches]';
  var cardSelector = '[data-combined-product-card]';
  var infiniteScrollObserver = null;
  var infiniteScrollFallbackHandler = null;
  var infiniteScrollLoading = false;

  function parseProducts(container) {
    var script = container && container.querySelector('[data-combined-product-json]');

    if (!script) {
      return [];
    }

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function findProduct(container, productId) {
    return parseProducts(container).find(function (product) {
      return String(product.id) === String(productId);
    });
  }

  function setImage(image, src, srcset, alt) {
    if (!image || !src) {
      return;
    }

    image.src = src;
    image.removeAttribute('data-src');

    if (srcset) {
      image.srcset = srcset;
      image.removeAttribute('data-srcset');
    }

    if (alt) {
      image.alt = alt;
    }
  }

  function updateActiveSwatch(container, selectedProductId) {
    container.querySelectorAll(swatchSelector).forEach(function (swatch) {
      var isActive = String(swatch.dataset.productId) === String(selectedProductId);

      swatch.classList.toggle('combined-product-swatches__swatch--active', isActive);
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateCard(card, product, swatches, activeSwatch) {
    var title = card.querySelector('[data-combined-product-card-title]');
    var price = card.querySelector('[data-combined-product-card-price]');
    var badge = card.querySelector('[data-combined-product-card-badge]');
    var isRevamp = card.classList.contains('product-card-revamp');
    var primaryImage = isRevamp
      ? card.querySelector('.product-card-revamp__image-ratio img, .product-card-revamp__image-mask img')
      : card.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask .image-wrap img');
    var secondaryImage = card.querySelector('.grid-product__secondary-image img, .product-card-revamp__secondary-image img');
    var links = card.querySelectorAll('[data-combined-product-card-link], .grid-product__link');
    var variantInputs = card.querySelectorAll('input[name="id"], select[name="id"], [data-product-select]');

    card.dataset.productId = product.id;
    card.dataset.productHandle = product.handle;
    card.dataset.selectedProductId = product.id;
    card.dataset.selectedVariantId = product.firstAvailableVariantId || '';
    card.setAttribute('data-limoniapps-discountninja-product-handle', product.handle);

    if (title) {
      if (product.fabricAndTitle && product.categoryAndColor) {
        title.innerHTML = '<span class="product-card-title__fabric">' + escapeHtml(product.fabricAndTitle) + '</span><span class="product-card-title__category">' + escapeHtml(product.categoryAndColor) + '</span>';
        title.classList.add('product-card-revamp__title--custom-meta');
      } else {
        var cardTitle = product.title || '';

        if (isRevamp && cardTitle.indexOf(' - ') > -1) {
          cardTitle = cardTitle.split(' - ')[0];
        }

        title.textContent = cardTitle;
        title.classList.remove('product-card-revamp__title--custom-meta');
      }
    }

    if (price && product.priceHtml && !isRevamp) {
      price.innerHTML = product.priceHtml.replace(/Rs\.?\s*/g, '₹ ').replace(/\/\-/g, '').replace(/₹\s+/g, '₹ ');
    }

    if (isRevamp && activeSwatch) {
      var swatchSubtitle = activeSwatch.getAttribute('data-product-subtitle');

      if (swatchSubtitle) {
        product = Object.assign({}, product, { subtitle: swatchSubtitle });
      }
    }

    if (badge) {
      badge.innerHTML = product.badgeHtml || '';
    }

    if (isRevamp && window.ProductCardRevamp && window.ProductCardRevamp.updateActiveSwatch) {
      window.ProductCardRevamp.updateActiveSwatch(card, product.id);
    } else {
      updateActiveSwatch(swatches, product.id);
    }

    setImage(primaryImage, product.featuredImage, product.featuredSrcset, product.title);
    setImage(secondaryImage, product.secondaryImage, product.secondarySrcset, product.title);

    links.forEach(function (link) {
      link.href = product.url;
    });

    variantInputs.forEach(function (input) {
      if (product.firstAvailableVariantId) {
        input.value = product.firstAvailableVariantId;
      }
    });

    if (isRevamp && window.ProductCardRevamp) {
      window.ProductCardRevamp.onSwatchChange(card, product);
    }
  }

  function getProductsPerRow(value) {
    value = String(value || '');
    return ['4', '5', '8'].indexOf(value) > -1 ? value : '4';
  }

  function getSavedProductsPerRow() {
    try {
      var savedValue = window.localStorage.getItem('collection-products-per-row');

      return ['4', '5', '8'].indexOf(savedValue) > -1 ? savedValue : '';
    } catch (error) {
      return '';
    }
  }

  function setSavedProductsPerRow(value) {
    try {
      window.localStorage.setItem('collection-products-per-row', getProductsPerRow(value));
    } catch (error) {}
  }

  function getCollectionImageSizes(value) {
    var selectedValue = getProductsPerRow(value);
    var desktopSize = selectedValue === '8' ? '12.5vw' : (selectedValue === '5' ? '20vw' : '25vw');

    return '(min-width: 769px) ' + desktopSize + ', 50vw';
  }

  function refreshCollectionImages(wrapper, value) {
    var grid = wrapper.querySelector('[data-collection-product-grid]');

    if (!grid) {
      return;
    }

    var imageSizes = getCollectionImageSizes(value);
    var eagerLoadLimit = window.innerHeight * 1.5;

    grid.querySelectorAll('.grid-product img.image-element').forEach(function (image) {
      image.setAttribute('sizes', imageSizes);

      var imageRect = image.getBoundingClientRect();

      if (imageRect.top < eagerLoadLimit && imageRect.bottom > -100) {
        image.loading = 'eager';

        if (image.currentSrc) {
          image.src = image.currentSrc;
        }
      }
    });

    if (window.AOS) {
      window.AOS.refreshHard();
    }
  }

  function applyCollectionProductsPerRow(value) {
    var selectedValue = getProductsPerRow(value);

    document.querySelectorAll('[data-collection-grid-wrapper]').forEach(function (wrapper) {
      wrapper.setAttribute('data-products-per-row', selectedValue);

      wrapper.querySelectorAll('[data-collection-products-per-row-button]').forEach(function (button) {
        var isActive = button.getAttribute('data-collection-products-per-row-button') === selectedValue;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      window.requestAnimationFrame(function () {
        refreshCollectionImages(wrapper, selectedValue);
      });
    });

    document.querySelectorAll('[data-collection-products-per-row-button]').forEach(function (button) {
      var isActive = button.getAttribute('data-collection-products-per-row-button') === selectedValue;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initCollectionProductsPerRow() {
    var savedValue = getSavedProductsPerRow();
    var firstWrapper = document.querySelector('[data-collection-grid-wrapper]');
    var defaultVal = (firstWrapper && firstWrapper.getAttribute('data-products-per-row')) || '4';

    applyCollectionProductsPerRow(savedValue || defaultVal);
  }

  function setInfiniteScrollLoading(container, isLoading) {
    var loader = container.querySelector('[data-collection-infinite-scroll-loader]');
    var spinner = container.querySelector('.collection-infinite-scroll__spinner');
    var text = container.querySelector('[data-collection-infinite-scroll-text]');

    infiniteScrollLoading = isLoading;

    if (spinner) {
      spinner.hidden = !isLoading;
    }

    if (text) {
      var loadingText = container.getAttribute('data-loading-text');
      text.textContent = isLoading ? (loadingText || '') : '';
      text.hidden = !isLoading || !loadingText;
    }

    if (loader) {
      loader.hidden = !isLoading;
    }
  }

  function getProductCardId(card) {
    return card && (card.getAttribute('data-product-id') || card.getAttribute('data-product-handle'));
  }

  function appendInfiniteScrollProducts(container, doc) {
    var currentGrid = document.getElementById('product-grid');
    var nextGrid = doc && doc.getElementById('product-grid');

    if (!currentGrid || !nextGrid) {
      return 0;
    }

    var existingIds = {};
    var appendedCount = 0;

    Array.prototype.slice.call(currentGrid.children).forEach(function (card) {
      if (!card.matches('.grid-product[data-product-id], .grid-product[data-product-handle]')) {
        return;
      }

      var cardId = getProductCardId(card);

      if (cardId) {
        existingIds[cardId] = true;
      }
    });

    Array.prototype.slice.call(nextGrid.children).forEach(function (card) {
      if (!card.matches('.grid-product[data-product-id], .grid-product[data-product-handle]')) {
        return;
      }

      var cardId = getProductCardId(card);

      if (cardId && existingIds[cardId]) {
        return;
      }

      if (cardId) {
        existingIds[cardId] = true;
      }

      currentGrid.appendChild(card);
      appendedCount++;
    });

    if (appendedCount > 0) {
      if (window.theme && theme.reinitProductGridItem) {
        theme.reinitProductGridItem();
      }

      initCollectionProductsPerRow();
      document.dispatchEvent(new CustomEvent('limoniapps:discountninja:collection:productsadded'));

      if (window.AOS) {
        window.AOS.refreshHard();
      }
    }

    return appendedCount;
  }

  function updateInfiniteScrollNextUrl(container, doc) {
    var nextContainer = doc && doc.querySelector('[data-collection-infinite-scroll]');
    var nextUrl = nextContainer ? nextContainer.getAttribute('data-next-url') : '';

    container.setAttribute('data-next-url', nextUrl || '');

    return nextUrl;
  }

  function markInfiniteScrollComplete(container) {
    var loader = container.querySelector('[data-collection-infinite-scroll-loader]');
    var text = container.querySelector('[data-collection-infinite-scroll-text]');
    var spinner = container.querySelector('.collection-infinite-scroll__spinner');

    container.setAttribute('data-complete', 'true');

    if (spinner) {
      spinner.hidden = true;
    }

    var completeText = container.getAttribute('data-complete-text');
    if (text) {
      text.textContent = completeText || '';
      text.hidden = !completeText;
    }

    if (loader) {
      loader.hidden = !completeText;
    }

    if (infiniteScrollObserver) {
      infiniteScrollObserver.unobserve(container);
    }
  }

  function loadNextInfiniteScrollPage(container) {
    var nextUrl = container.getAttribute('data-next-url');

    if (infiniteScrollLoading || !nextUrl || container.getAttribute('data-complete') === 'true') {
      return;
    }

    setInfiniteScrollLoading(container, true);

    fetch(nextUrl, {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to load next collection page');
      }

      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var appendedCount = appendInfiniteScrollProducts(container, doc);
      var nextPageUrl = updateInfiniteScrollNextUrl(container, doc);

      setInfiniteScrollLoading(container, false);

      if (!nextPageUrl || appendedCount === 0) {
        markInfiniteScrollComplete(container);
      }
    }).catch(function () {
      setInfiniteScrollLoading(container, false);
      markInfiniteScrollComplete(container);
    });
  }

  function initCollectionInfiniteScroll() {
    var container = document.querySelector('[data-collection-infinite-scroll]');

    if (infiniteScrollObserver) {
      infiniteScrollObserver.disconnect();
      infiniteScrollObserver = null;
    }

    if (infiniteScrollFallbackHandler) {
      window.removeEventListener('scroll', infiniteScrollFallbackHandler);
      infiniteScrollFallbackHandler = null;
    }

    infiniteScrollLoading = false;

    if (!container) {
      return;
    }

    var nextUrl = container.getAttribute('data-next-url');

    if (!nextUrl || container.getAttribute('data-complete') === 'true') {
      setInfiniteScrollLoading(container, false);
      markInfiniteScrollComplete(container);
      return;
    }

    setInfiniteScrollLoading(container, false);

    if (!('IntersectionObserver' in window)) {
      infiniteScrollFallbackHandler = function () {
        var rect = container.getBoundingClientRect();

        if (rect.top < window.innerHeight + 600) {
          loadNextInfiniteScrollPage(container);
        }
      };

      window.addEventListener('scroll', infiniteScrollFallbackHandler, { passive: true });
      return;
    }

    infiniteScrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextInfiniteScrollPage(container);
        }
      });
    }, {
      rootMargin: '600px 0px'
    });

    infiniteScrollObserver.observe(container);
  }

  document.addEventListener('click', function (event) {
    var perRowButton = event.target.closest('[data-collection-products-per-row-button]');

    if (perRowButton) {
      var productsPerRow = perRowButton.getAttribute('data-collection-products-per-row-button');

      setSavedProductsPerRow(productsPerRow);
      applyCollectionProductsPerRow(productsPerRow);
      return;
    }

    var swatch = event.target.closest(swatchSelector);

    if (!swatch) {
      return;
    }

    var swatches = swatch.closest(swatchesSelector);

    if (!swatches) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var product = findProduct(swatches, swatch.dataset.productId);

    if (!product) {
      return;
    }

    if (swatches.dataset.combinedProductContext === 'pdp') {
      window.location.href = product.url;
      return;
    }

    var card = swatch.closest(cardSelector);

    if (card) {
      updateCard(card, product, swatches, swatch);
    }
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll(swatchesSelector).forEach(function (swatches) {
      var card = swatches.closest(cardSelector);

      if (card && card.classList.contains('product-card-revamp')) {
        return;
      }

      updateActiveSwatch(swatches, swatches.dataset.currentProductId);
    });

    initCollectionProductsPerRow();
    initCollectionInfiniteScroll();

    if (window.ProductCardRevamp && window.ProductCardRevamp.initCards) {
      window.ProductCardRevamp.initCards(event.target);
    }
  });

  document.addEventListener('collection:reloaded', function () {
    initCollectionProductsPerRow();
    initCollectionInfiniteScroll();
  });

  function initOnReady() {
    initCollectionProductsPerRow();
    initCollectionInfiniteScroll();

    if (window.ProductCardRevamp && window.ProductCardRevamp.initCards) {
      window.ProductCardRevamp.initCards(document);
    }
  }

  if (document.readyState !== 'loading') {
    initOnReady();
  } else {
    document.addEventListener('DOMContentLoaded', initOnReady);
  }
})();
